<template>
  <div id="app">
    <div>
      <Navbar />
      <!-- <Navbar @allRef="findAllRef" /> -->
    </div>
    <router-view />
    <div class="copy-right-style"> © COPYRIGHT 2021 AVILON ROBOTICS - ALL RIGHT RESERVED</div>
  </div>
</template>

<script>
export default {
  components: {
    Navbar: () => import('@/components/Navbar.vue')
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins');
html *
{
   font-family: 'Poppins', sans-serif !important;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.copy-right-style{
  padding: 10px;
}
</style>
